import react, {useCallback, useEffect, useState, useRef} from 'react';
import  {getUserList, getInvalidateDay, createUserList, getSpots, removeUsers} from '../../lib/firebase';
import XLSX from 'xlsx';
import moment from 'moment';

export default function useUser(){
    
    const [userList, setUserList] = useState<any>([false]);
    const [focus, setFocus] = useState<any>();
    const [open, setOpen] = useState(false);
    const [invalidate, setInvalidate] = useState<number>(0);
    const [user, setUser] = useState<any>();
    const [spots, setSpots] = useState<any>();
    const inputRef = useRef<HTMLInputElement>(null);
    const userInputRef = useRef<HTMLInputElement>(null);
    const [password, setPassword] = useState<any>(0);

    const handleUserList = async() =>{
        try{
            const value = await getUserList();
            const list = value.val();
            
            setUserList(Object.entries(list ?? {}) as any);
            
        }catch(e){
            console.log(e);
        }
    }

    const handleSpotList = async() => {
        try{
            const value = await getSpots();
            const list = value.val();
            
            setSpots(Object.entries(list) as any);

            const main: any = Object.entries(list).find((o:any) => o[1].name === '본사');
            console.log(main);
            
            setPassword(main[1].password);  
            
            
        }catch(e){
            console.log(e);
        }
    }

    const handleRemoveUsers = async() => {
        try{
            const isRemove = window.confirm('모든 유저가 삭제됩니다. 정말로 진행하시겠습니까?');
            if ( isRemove ){
                await removeUsers();
                handleUserList();
            }
        } catch(e){
            console.log(e);
        }
    }

    const handleInvalidate = async() => {
        try{
            const value = await getInvalidateDay();
            setInvalidate(value.val());
        } catch(e){
            console.log(e);
            
        }
    }

    const show = (user) => {
        setFocus(user);
        setOpen(true);
    }
    const close = () => setOpen(false);

    const searchUser = (name: string, phoneNum: string) => {
        console.log(name, phoneNum);
        
        const findUser = userList?.find(user => user[1].name === name && user[1].phoneNum === phoneNum);
        if ( !findUser ){
            window.alert('해당하는 회원을 찾을 수 없습니다.');
            return;
        }
    
        setUser(findUser[1]);
    }

    const onReadExcel = () => {
        inputRef.current?.click();
    }

    const exportUserList = () => {
        const excelList = userList.map( user => {
            const {points, key, name, phoneNum, spot, registeredAt, userLevel,  residence, birthDay} = user[1];
            const totalPoint = points ? points.reduce((acc, p) => acc + p.point, 0) : 0;
            return {
                회원번호: key,
                회원명: name,
                핸드폰번호: phoneNum,
                가입매장: spot,
                가입일: moment(new Date(registeredAt)),
                회원등급: userLevel,
                거주지: residence,
                생년월일: birthDay,
                누적포인트: totalPoint,
            }
        });
        const worksheet = XLSX.utils.json_to_sheet(excelList); 
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, 'SheetJS');
        XLSX.writeFile(new_workbook, '회원정보.xlsx');
    }

    const onChangeUserExcelInput = (e) => {
        const {files} = e.target;
        let reader = new FileReader();

        reader.onload = function () {
            let data = reader.result;
            let workBook = XLSX.read(data, { type: 'binary' });
            workBook.SheetNames.forEach( async(sheetName) => {
                console.log('SheetName: ' + sheetName);
                let rows = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
                const list: Array<any> = JSON.parse(JSON.stringify(rows)) ;

                const dataList = list.filter(l => userList.every(u => u[1] !== l['회원번호'])).map(data => {
                    return [
                        data['회원번호'],
                        {
                            key: data["회원번호"] ?? "",
                            name: data["회원명"] ?? "",
                            phoneNum: data["핸드폰번호"] ?? "",
                            spot: data["가입매장"] ?? "",
                            registerAt: data["가입일"] ?? "",
                            userLevel: data['회원등급'] ?? "",
                            residence: data["거주지"] ?? "",
                            birthDay: data["생년월일"] ?? "",
                            points: [{point: data["적립포인트"]}],
                        }
                    ]
                });
                try{
                    await createUserList(Object.fromEntries([...dataList, ...userList]));
                    window.alert('등록이 완료되었습니다!');
                }catch(e){
                    console.log(e);
                }

            });
            
            
        };

        reader.readAsBinaryString(files[0]);
    }
    const onChangeExcelInput = (e) => {
        const {files} = e.target;
        let reader = new FileReader();
        
        reader.onload = ()=> {
            let data = reader.result;
            let workBook = XLSX.read(data, { type: 'binary' });
            workBook.SheetNames.forEach(async(sheetName)=> {
                console.log('SheetName: ' + sheetName);
                let rows = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
                const list: Array<any> = JSON.parse(JSON.stringify(rows));
                
                const newUserList = userList.map( user => {
                    const findUser = list.filter( l => l['회원번호'] === user[0]);;
                    const lastPoint = findUser.reduce( (acc, user) => acc + ((user['적립'] ?? 0)+ ((user['사용']??0)* -1)), 0);
                    
                    return [
                        user[0],
                        {
                            ...user[1],
                            points: findUser.length !== 0 ? [...user[1].points, {point: lastPoint ?? 0}] : user[1].points,
                            logs : findUser.map( log => {
                                
                                console.log(log);
                                
                                return {
                                    date: log['포인트일자'],
                                    newPoint: log['적립'] ?? 0,
                                    usePoint: log['사용'] ?? 0,
                                    spot: log['발생매장'],
                                    price: 0,
                                }
                            })
                        }
                    ]
                });
                try{
                    await createUserList(Object.fromEntries([ ...newUserList]));
                    window.alert('등록이 완료되었습니다!');
                }catch(e){
                    alert(e);
                    console.log(e);
                }
            });
        };

        reader.readAsBinaryString(files[0]);
    }

    const onReadUserExcel = () => {
        userInputRef.current?.click();
    }

    useEffect(
        ()=>{
            handleSpotList();
            handleUserList();
            handleInvalidate();
            
        }, []
    )

    return {
        userList, open, show, close, focus, invalidate, user, searchUser, onReadExcel, inputRef, onChangeExcelInput, exportUserList, userInputRef, onChangeUserExcelInput, onReadUserExcel,
        password, handleRemoveUsers
    }
}